/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? /*@__PURE__*/ Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
export var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/symbol/rxSubscriber.js
// module id = 65
// module chunks = 1